import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { FIELD_CONTROL, FIELD_CONFIG } from './field-tokens';

@Component({
  selector: 'app-field-currency',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, InputNumberModule],
  template: `
    <p-inputnumber
      [formControl]="formControl"
      mode="decimal"
      [minFractionDigits]="2"
      [maxFractionDigits]="2"
      [placeholder]="config.placeholder || '0.00'"
      [readonly]="!!config.disabled"
      styleClass="w-full" />
  `
})
export class CurrencyFieldComponent {
  readonly config  = inject(FIELD_CONFIG);
  readonly control = inject(FIELD_CONTROL);
  get formControl(): FormControl { return this.control as FormControl; }
}
